import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { INode } from './INode';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wbm-config-tree',
    templateUrl: './config-tree.component.html',
    styleUrls: ['../../assets/theme/css/ConfigTree.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConfigTreeComponent implements OnInit, OnDestroy {
    @Input() public nodes: Array<INode>;

    private subscriptions: Array<Subscription> = [];

    constructor(private cd: ChangeDetectorRef) { }

    ngOnInit() {
        if (!!this.nodes) {
            this.nodes.forEach(subNode => {
                this.subscriptions.push(subNode.isUsedChanges().subscribe(() => {
                    this.cd.markForCheck();
                }));
            });
        }
    }

    ngOnDestroy() {
        //release global subscriptions
        this.removeGlobalSubscriptions();
    }

    private removeGlobalSubscriptions() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().unsubscribe();
        }
    }
}
